export default function Privacy() {
	return (
		<div className="container py-12">
			<h1 className="text-3xl font-bold">Privacy Policy</h1>
			<p className="mt-4 text-gray-600">Coming soon.</p>
		</div>
	);
}
